export const ServicesData = [
    {
        'id' : 1,        
        'title' : 'Master Chefs',
        'desc' : 'Diam elitr kasd sed at elitr sed ipsum justo dolor sed clita amet diam',
        'icon': 'fa  fa-user-tie '
    },
    {
        'id' : 2,        
        'title' : 'Quality Food',
        'desc' : 'Diam elitr kasd sed at elitr sed ipsum justo dolor sed clita amet diam',
        'icon': 'fa  fa-utensils '
    },
    {
        'id' : 3,        
        'title' : 'Online Order',
        'desc' : 'Diam elitr kasd sed at elitr sed ipsum justo dolor sed clita amet diam',
        'icon': 'fa fa-cart-plus '
    },
    {
        'id' : 4,        
        'title' : '24/7 Services',
        'desc' : 'Diam elitr kasd sed at elitr sed ipsum justo dolor sed clita amet diam',
        'icon': 'fa fa-headset '
    },
]